<template>
    <div id="type">
        <el-card shadow = "never">
            <el-row>
                    <el-col :span="8">
                        <el-button-group>
                            <el-button type="info" icon="el-icon-refresh" @click="refreshTypes">刷新</el-button>
                            <el-button type="info" icon="el-icon-circle-plus" @click="addTypes">添加产品类型</el-button>
                        </el-button-group>
                    </el-col>
                    <el-col :span="6" class="serch-input" style="float:right;">
                        <el-input placeholder="请输入类型编号" v-model="input5" class="input-with-select" clearable>
                            <!-- <el-button slot="append" icon="el-icon-search" @click="findUser(input5)"></el-button> -->
                        </el-input>
                    </el-col>
                </el-row>
                <el-row class="typeList">
                    <el-col :span="24">
                        <el-table
                            v-loading ="loading"
                            element-loading-text = '加载中'
                            :data = 'tableData .filter(data => !input5 || data.typeCode.includes(input5.toUpperCase()))'
                            height="400px"
                            border
                            style="width:100%"
                        >
                            <el-table-column
                                prop="typeCode"
                                label="类型编号"
                                width="100"
                                header-align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="description"
                                label="类型名称"
                                show-overflow-tooltip
                                width="150"
                                header-align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="lastUpdateDate"
                                label="最后更新日期"
                                header-align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="lastUpdateUser"
                                label="最后更新用户"
                                width="120"
                                header-align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="operation"
                                label="操作"
                                header-align="center"
                            >
                                <template slot-scope="scope">
                                    <el-row>
                                        <el-button-group>
                                            <el-tooltip class="item" effect="dark" content="修改" placement="bottom">
                                                <el-button  @click.native.prevent="revise(scope.$index,scope.row)" type="info" size="small" plain icon="el-icon-edit"  class="operateBtn"></el-button>
                                            </el-tooltip> 
                                            <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                                                <el-button type="danger" size="small" icon="el-icon-delete" @click.native.prevent="deleteRow(scope.$index, tableData)" class="operateBtn"></el-button>
                                            </el-tooltip>
                                        </el-button-group>
                                    </el-row>
                                </template>                                             
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-row>
        </el-card>
    </div>
</template>
<style lang="less">
    #type{
        .typeList{
            margin: 20px 0;
        }
    }
</style>
<script>
import requestMixin from '../../mixins/request'
import common from '../../mixins/common'
import axios from '../../env/axios'
import apis from '../../env/apis';
export default {
    mixins:[requestMixin,common],
    data(){
        return {
            input5:"",
            loading:false,
            tableData:[
                {
                    typeCode:'',
                    description:'',
                    lastUpdateDate:'',
                    lastUpdateUser:""
                }
            ]
        }
    },
    mounted(){
        this.$nextTick(function () {
            this.refreshTypes();
        })
    },
    methods:{
        /**
         * 添加产品类型
         */
        addTypes(){
            this.$router.push('addtypes');
        },

        /**
         * 删除产品类型
         */
        deleteRow(index,rows){
            let typeCode = rows[index].typeCode;
            let userId = sessionStorage.getItem("userId") ;
            this.$confirm('确定删除',"提示",{
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(()=>{
                let params = {
                    act:'delType',
                    typeCode:typeCode,
                    userId
                }
                //console.log(params)
                this.delType(params).then((res) => {
                    if(res.data.status == true){
                        this.$message({
                            type: 'success',
                            message: '删除成功 √ '
                        });
                        this.refreshTypes();
                    }else{
                        // console.log(res)
                        if(res.data.msg){
                            this.alert(res.data.msg ,'warning')
                        }else{
                            this.alert('不能删除 !','warning')
                        }
                    }
                })
            }).catch((error) => {
                this.$message({
                    type:'info',
                    message:'已取消删除'
                })
            })
        },
        /**
         * 修改账户信息
         */
        revise(index,rows){
            let typeCode = rows.typeCode ;
            this.getUserIndex("findTypes",elem => elem.typeCode == typeCode).then((res) =>{
                // console.log(res)
                this.$router.push({
                    path:'/system/editType',
                    query:{
                        index:res
                    }
                })
            })
            
        },
        /**
         * 获取删除数据
        */
        async delType(params){
            let result;
            await axios.post( apis.baseURL ,params)
                .then((res) => {
                    result = res ;
                })
                .catch( (error) => {
                    this.$alert('请求不到数据或网络连接异常','提示',{
                        confirmButtonText:'确定',
                        type:'error',
                        center:true
                    });
                })
                return result;
        },
        /**
         * 产品类型刷新按钮
         */
        refreshTypes(){
            this.loading = true;
            let userId = sessionStorage.getItem("userId") ;
            let params = {
                act:'findTypes',
                userId
            }
            this.findType(params).then( (res) => {
                if(res.data.status == true){
                    let result = res.data.list ;
                    this.loading = false;
                    // this.sortChinese(result,"typeCode")
                    this.tableData = result ;
                }else{
                    this.loading = false;
                    this.promptMsg('加载失败','提示')
                } 
            })
        }
    }
}
</script>
